import { CommonModule } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { UpsellModalComponent } from "src/app/components/upsell-modal/upsell-modal.component";
import { SharedModule } from "src/app/shared/shared.module";
import { BrandReviewsComponent } from "src/components/brand-reviews/brand-reviews";
import { UpsellButtonsComponent } from 'src/components/upsell-buttons/upsell-buttons';
import { UpsellFooterComponent } from "src/components/upsell-footer/upsell-footer";
import { UpsellOfferSpinnerV2Component } from "src/components/upsell-offer-spinner-v2/upsell-offer-spinner-v2";
import { UpsellOfferSpinnerComponent } from 'src/components/upsell-offer-spinner/upsell-offer-spinner';
import { UpsellProductBoxFullComponent } from "src/components/upsell-product-box-full/upsell-product-box-full";
import { UpsellProductBoxComponent } from "src/components/upsell-product-box/upsell-product-box";
import { UpsellSectionComponent } from "src/components/upsell-section/upsell-section";
import { UpsellStepsComponent } from "src/components/upsell-steps/upsell-steps";
import { UpsellStickyBarV2 } from "src/components/upsell-sticky-bar-v2/upsell-sticky-bar-v2";
import { UpsellStickyBar } from "src/components/upsell-sticky-bar/upsell-sticky-bar";
import { UpsellWaitComponent } from "src/components/upsell-wait/upsell-wait";
import { UpsellWhyComponent } from "src/components/upsell-why/upsell-why";
import { UpsellCTAComponent } from "src/components/upsell-cta/upsell-cta";
import { FaqsComponent } from "src/components/faqs/faqs";
import { VideoPlayerComponent } from "src/components/video-player/video-player";
import { UpsellProductBoxTBYBComponent } from 'src/components/upsell-product-box-tbyb/upsell-product-box-tbyb';
import { UpsellMBGComponent } from "src/components/upsell-mbg/upsell-mbg";
import { UpsellDocComponent } from "src/components/upsell-doc/upsell-doc";
import { UpsellHeaderComponent } from "src/components/upsell-header/upsell-header";
import { UpsellFaqsComponent } from "src/components/upsell-faq/upsell-faq";
import { VideoPlayerVidalyticsComponent } from "src/components/video-player-vidalytics/video-player-vidalytics";

@NgModule({
  declarations: [
    BrandReviewsComponent,
    UpsellCTAComponent,
    UpsellButtonsComponent,
    UpsellFooterComponent,
    UpsellModalComponent,
    UpsellOfferSpinnerComponent,
    UpsellOfferSpinnerV2Component,
    UpsellProductBoxComponent,
    UpsellProductBoxFullComponent,
    UpsellSectionComponent,
    UpsellStepsComponent,
    UpsellStickyBar,
    UpsellStickyBarV2,
    UpsellWaitComponent,
    UpsellWhyComponent,
    FaqsComponent,
    VideoPlayerComponent,
    UpsellProductBoxTBYBComponent,
    UpsellMBGComponent,
    UpsellDocComponent,
    UpsellHeaderComponent,
    UpsellFaqsComponent,
    VideoPlayerVidalyticsComponent
  ],
  exports: [
    BrandReviewsComponent,
    UpsellCTAComponent,
    UpsellButtonsComponent,
    UpsellFooterComponent,
    UpsellModalComponent,
    UpsellOfferSpinnerComponent,
    UpsellOfferSpinnerV2Component,
    UpsellProductBoxComponent,
    UpsellProductBoxFullComponent,
    UpsellSectionComponent,
    UpsellStepsComponent,
    UpsellStickyBar,
    UpsellStickyBarV2,
    UpsellWaitComponent,
    UpsellWhyComponent,
    FaqsComponent,
    VideoPlayerComponent,
    UpsellProductBoxTBYBComponent,
    UpsellMBGComponent,
    UpsellDocComponent,
    UpsellHeaderComponent,
    UpsellFaqsComponent,
    VideoPlayerVidalyticsComponent
  ],
  imports: [CommonModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UpsellModule { }